<template>
<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.81802 17.1819C3.13604 18.5 5.25735 18.5 9.5 18.5C13.7426 18.5 15.864 18.5 17.1819 17.1819C18.5 15.864 18.5 13.7426 18.5 9.5C18.5 9.19265 18.5 9.03902 18.4863 8.88278C18.4228 8.15441 18.1274 7.44131 17.6573 6.8813C17.5564 6.76118 17.4452 6.64985 17.2225 6.4272L12.5728 1.7775C12.3501 1.55485 12.2388 1.44351 12.1187 1.34268C11.5587 0.8726 10.8456 0.577229 10.1172 0.513635C9.96098 0.5 9.80735 0.5 9.5 0.5C5.25735 0.5 3.13604 0.5 1.81802 1.81802C0.5 3.13604 0.5 5.25735 0.5 9.5C0.5 13.7426 0.5 15.864 1.81802 17.1819Z" stroke="white"/>
<path d="M14 18.5V17.6C14 15.903 14 15.0544 13.4728 14.5272C12.9456 14 12.097 14 10.4 14H8.6C6.90294 14 6.05441 14 5.52721 14.5272C5 15.0544 5 15.903 5 17.6V18.5" stroke="white"/>
<path d="M5 5.8999H10.4" stroke="white" stroke-linecap="round"/>
</svg>
</template>
<script>
export default {
  name: 'IconSave'
}
</script>
